import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {roi_tool_template} from "../components/templates/roi_tool_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class roi_tool extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected roi_tool_template: roi_tool_template;

    protected getModuleName(){
        return "roi_tool";
    }

    buildContent() : Array<Element>{

        this.roi_tool_template = new roi_tool_template( "roi_tool", this.viewModel, this );
        this.template = this.roi_tool_template;

        return [this.roi_tool_template.build()];
    }

    public fillPage() : void{
        // todo uncomment if we decide to keep this report
        /*
        this.roi_tool_template.initiateDimensionSelectTag();
        this.roi_tool_template.buildDatePickerCalendar();

        this.getSearchPresetsListData();
        */
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/roi_tool/list_form_data';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();

    }

    public getListData(): void{

        this.loadingIn(this.roi_tool_template.builtTemplate.children.namedItem("list-results"));
        this.roi_tool_template.hideExportButton();
        this.roi_tool_template.hideExportReconciliationButton();
        this.roi_tool_template.validateOrderBy();

        let subViewModel = this.roi_tool_template.getViewModelForRequest();
        let baseApiUrl = '/api/roi_tool/list_data';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword): void{

        let subViewModel = {
            filters      : {
                keyword : keyword,
            }
        };

        let usrReq_url;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        if(id == 'primaryCategoriesFilter'){
            usrReq_url = '/api/emakiCategorySuggestions/';
        }

        if(id == 'srEditorsFilter'){
            usrReq_url = '/api/emakiUsers/get/';
        }

        if(id == 'jrEditorsFilter'){
            usrReq_url = '/api/emakiUsers/get/';
        }

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        if(id == 'primaryCategoriesFilter'){
            this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompleteCategoriesSuggestionsReturn;
        }

        if(id == 'srEditorsFilter'){
            this.XHRHdl.onReadyStateFunction = this.onGetAutoCompleteSrEditorsSuggestionsReturn;
        }

        if(id == 'jrEditorsFilter'){
            this.XHRHdl.onReadyStateFunction = this.onGetAutoCompleteJrEditorsSuggestionsReturn;
        }

        this.XHRHdl.execute();
    }

    protected onGetMultipleAutoCompleteCategoriesSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.roi_tool_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.roi_tool_template.setPrimaryCategoriesFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.roi_tool_template.deactivateLoading();
            });
        }
    }

    protected onGetAutoCompleteSrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.roi_tool_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.roi_tool_template.setSrEditorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.roi_tool_template.deactivateLoading();
            });
        }
    }

    protected onGetAutoCompleteJrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.roi_tool_template.validationsList.clearMessages();

                if(responseParsed.data){

                    obj.roi_tool_template.setJrEditorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.roi_tool_template.deactivateLoading();
            });
        }
    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.roi_tool_template.validationsList.clearMessages();

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();

                // LOADING : ends
                obj.loadingOut(obj.roi_tool_template.builtTemplate);
            });
        }
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.roi_tool_template.validationsList.clearMessages();
                obj.updateList(responseParsed.data);

                // LOADING : ends
                obj.loadingOut(obj.roi_tool_template.builtTemplate.children.namedItem("list-results"));
            });
        };
    }

    protected updateFilters(responseParsed: any){

        this.roi_tool_template.setBrandFilterItems(responseParsed.departments);
        this.roi_tool_template.setPostInitiativesFilterItems(responseParsed.postInitiatives);
        this.roi_tool_template.setPostIntentsFilterItems(responseParsed.postIntents);
        this.roi_tool_template.setPostContentTypesFilterItems(responseParsed.groupedContentTypes);
        this.roi_tool_template.setNetworkCategoriesFilterItems(responseParsed.groupedNetworkCategories);
        this.roi_tool_template.setPublishStatusItems();
        this.roi_tool_template.setCostsFilterItems();
        this.roi_tool_template.setPermissions(responseParsed.permissions);
    }

    protected updateList(responseParsed: any) {

        for (let item of responseParsed.roiDataPerDimensionGroupings) {
            item.Day = this.formatDate(item.Day + "T12:00:00");
        }

        this.roi_tool_template.setRoiData(responseParsed);
        this.roi_tool_template.setInProgress(responseParsed.inProgress);

        this.roi_tool_template.setFinancialPermissions(responseParsed.financialPermissions);
        this.roi_tool_template.setCostPermissions(responseParsed.costPermissions);

    }

    protected filterMultipleSelectorOnChange(){
        this.roi_tool_template.resetDefaultDimensionFilters();
        this.roi_tool_template.setSelectDimensionsObjects();
        this.getListData();
    }

    protected filterDateOnChange(){
        this.getListData();
    }

    protected filterSimpleOnChange(){
        this.getListData();
    }

    public listReorder(){
        this.getListData();
    }

    private formatDate(date) {
        let weekday = new Array(7);
        weekday[0] = "Sun";
        weekday[1] = "Mon";
        weekday[2] = "Tue";
        weekday[3] = "Wed";
        weekday[4] = "Thu";
        weekday[5] = "Fri";
        weekday[6] = "Sat";

        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            dayOfWeek = weekday[d.getDay()];


        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return dayOfWeek + ', ' + [year, month, day].join('-');
    }

    public getCsvReconciliationData(idReport): void {

        let subViewModel = this.roi_tool_template.getViewModelForRequest();
        let usrReq_url = '/api/roi_tool/reconciliation_data';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetCsvReconciliationDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetCsvReconciliationDataReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);

                obj.roi_tool_template.setExportReconciliationData(response.data.reconciliationData);
            });
        }
    }

}



// WEBPACK FOOTER //
// ./js/modules/roi_tool.ts